import React, { useState, useEffect, useRef } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import CloseIcon from "../../shared/CloseIcon";
import useFlexiblePaymentModalData from "./flexible-payment-modal-data";
import { theme } from "../../../utils/global-styles/theme";
import { useSelector, useDispatch } from "react-redux";
import { SET_SUGGESTED_PRICE } from "../../../state/constants/payment";
const FlexiblePaymentModal = ({
  showFlexiblePaymentModal,
  setShowFlexiblePaymentModal,
  handleEnrollmentClick,
  suggestedPrice: suggestedCoursePrice,
  currencySymbol,
}) => {
  const {
      description,
      inputFieldLabel,
      paymentButton,
      suggestedPrice,
    } = useFlexiblePaymentModalData(),
    Wrapper = styled.div`
      position: fixed;
      z-index: 100;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: auto;
      background-color: rgb(0, 0, 0);
      background-color: rgba(0, 0, 0, 0.4);
      font-family: ${theme.fontFaces.paragraphs};
    `,
    ModalContent = styled.div`
      background-color: white;
      margin: 5% auto;
      margin-top: 18%;
      padding: 20px 5%;
      border: 1px solid #888;
      width: 60%;
      overflow: auto;
    `,
    Description = styled.div`
      display: block;
      color: black;
      width: 100%;
      margin-top: 10%;
      margin-bottom: 8%;
      font-size: 1.15em;
    `,
    InputRow = styled.div`
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      margin-bottom: 4%;
    `,
    ButtonWrapper = styled.div`
      display: flex;
      flex-direction: column;
      width: 30%;
    `,
    SuggestedPrice = styled.div`
      font-size: 0.7em;
      width: 100%;
    `,
    InputWrapper = styled.div`
      width: 65%;
      display: flex;
      flex-direction: column;
    `,
    PaymentCtaButton = styled.button`
      float: right;
    `,
    Prepend = styled("div")`
      position: relative;
      top: 1.1em;
      font-weight: bold;
      font-size: 22px;
      background-color: white;
      padding: 0 8px;
      left: 4px;
    `,
    StyledTextInput = styled("input")`
      background-color: transparent;
      border: none;
      width: 100%;
      padding-left: 35px;
      &:focus {
        outline: none;
      }
      &::placeholder {
        color: #fff;
      }
    `,
    InputWrap = styled("div")`
      border: 1px solid #fff;
    `,
    StyledErrorText = styled("p")`
      margin-bottom: 15px;
      font-family: ${theme.fontFaces.help};
    `,
    [error, setError] = useState(false),
    dispatch = useDispatch(),
    payment = useSelector(state => state.paymentReducer),
    suggestedAmountRegex = new RegExp(/[^\d\.\,\s]+/),
    handleChange = e => {
      if (
        e.target.value.charAt(0) === "$" ||
        e.target.value.charAt(0) === "€" ||
        e.target.value.charAt(0) === "£"
      ) {
        if (!suggestedAmountRegex.test(e.target.value.substring(1))) {
          dispatch({
            type: SET_SUGGESTED_PRICE,
            payload: e.target.value.substring(1),
          });
        }
      } else {
        if (e.target.value.length > 0) {
          if (!suggestedAmountRegex.test(e.target.value)) {
            dispatch({ type: SET_SUGGESTED_PRICE, payload: e.target.value });
          }
        } else {
          dispatch({ type: SET_SUGGESTED_PRICE, payload: e.target.value });
        }
      }
    },
    setSuggestedPriceInInput = courseCost => {
      if (
        courseCost.charAt(0) === "$" ||
        courseCost.charAt(0) === "€" ||
        courseCost.charAt(0) === "£"
      ) {
        dispatch({
          type: SET_SUGGESTED_PRICE,
          payload: courseCost.substring(1),
        });
      } else {
        dispatch({ type: SET_SUGGESTED_PRICE, payload: courseCost });
      }
    };

  return (
    <Wrapper
      css={css`
        display: ${showFlexiblePaymentModal ? "block" : "none"};
      `}
    >
      <ModalContent>
        <CloseIcon
          styles={`
                float: right;
                font-weight: bold;
                `}
          width={"15px"}
          height={"15px"}
          color={"black"}
          onClick={() => {
            setShowFlexiblePaymentModal(false);
          }}
        />
        <Description>{description.description}</Description>
        <InputRow>
          <ButtonWrapper>
            <SuggestedPrice className={"primary"}>
              {suggestedPrice}
            </SuggestedPrice>
            <button
              className={"black-button"}
              onClick={() => setSuggestedPriceInInput(suggestedCoursePrice)}
            >
              {suggestedCoursePrice}
            </button>
          </ButtonWrapper>
          <InputWrapper>
            <InputWrap
              css={css`
                border-color: ${theme.colors.accent};
                border-width: 2px;
                border-style: solid;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: 100%;
                padding: 0px 0px 16px 12px;
                @media only screen and (max-width: ${theme.breakpoints
                    .helper1100}) {
                  width: 100%;
                }
              `}
            >
              <label
                css={css`
                  font-weight: bold;
                  font-family: ${theme.fontFaces.inputPlaceholders};
                  position: relative;
                  top: -0.75em;
                  background-color: white;
                  padding: 0 8px;
                  left: 4px;
                  font-size: 14px;
                  line-height: 17px;
                `}
              >
                {`${inputFieldLabel.split("$")[0]} ${currencySymbol}0`}
              </label>
              <Prepend>{currencySymbol}</Prepend>
              <StyledTextInput
                required={true}
                type="text"
                value={payment.suggestedPrice}
                css={css`
                  font-size: 18px;
                `}
                autoFocus
                onChange={e => handleChange(e)}
              />
            </InputWrap>
            {error && <StyledErrorText>{error}</StyledErrorText>}
          </InputWrapper>
        </InputRow>

        <PaymentCtaButton
          className={"black-button"}
          onClick={() =>
            payment.suggestedPrice.length > 0
              ? handleEnrollmentClick(payment.suggestedPrice)
              : {}
          }
          css={css`
            opacity: ${payment.suggestedPrice.length > 0 ? "1" : "0.6"};
            cursor: ${payment.suggestedPrice.length > 0
              ? "pointer"
              : "not-allowed"};
          `}
        >
          {paymentButton}
        </PaymentCtaButton>
      </ModalContent>
    </Wrapper>
  );
};

export default FlexiblePaymentModal;
